export const NIC_INTRO_BANNER_ASSETS = {
  mediaImageSrc: '/assets/images/mycexnic-lockup.svg',
};
